import { useEffect, useState } from "react";

interface UseSignalChipStateParams {
	prospectId: number;
	seedSignalId?: number;
	triggerDescription?: string | null;
	batchMode: boolean;
	isBulk: boolean;
}

/**
 * Whether the GenerateBar's selected-signal chip is shown and its signal is sent. Extracted from
 * `GenerateBar` to keep that file under the length gate.
 *
 * The user can remove the chip to generate without the signal; that choice is reset whenever the
 * lead or the seeded signal changes, so a new lead starts with its signal considered again. The
 * chip is shown only in single-lead mode, when the lead has a signal the user has not removed.
 */
export const useSignalChipState = ({
	prospectId,
	seedSignalId,
	triggerDescription,
	batchMode,
	isBulk,
}: UseSignalChipStateParams) => {
	const [signalDismissed, setSignalDismissed] = useState(false);

	useEffect(() => {
		setSignalDismissed(false);
	}, [prospectId, seedSignalId]);

	return {
		signalDismissed,
		dismissSignal: () => setSignalDismissed(true),
		showSignalChip:
			!batchMode && !isBulk && !!seedSignalId && !!triggerDescription && !signalDismissed,
		signalActive: !!seedSignalId && !signalDismissed,
	};
};
